import { useGlobalSearchParams, usePathname } from 'expo-router'
import { useEffect } from 'react'
import Analytics from './Analytics'

const useScreenTracking = () => {
  const pathname = usePathname()
  const params = useGlobalSearchParams()

  // Track the location in your analytics provider here.
  useEffect(() => {
    Analytics.trackScreen(pathname, params)
  }, [pathname, params])
}

export default useScreenTracking
